import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {NavbarComponent} from '../../components/navbar/navbar.component';
import {AffairesService} from '../../services/affaires.service';
import {HttpClientModule} from '@angular/common/http';
// TODO: Document in interfaces dir
import {Affair, Document} from '../../affaires/affaires-list/affaires-list.component';
import {NgClass, NgForOf, NgIf} from '@angular/common';
import {MatTab, MatTabGroup, MatTabLink, MatTabsModule} from '@angular/material/tabs';
import {MatIcon} from '@angular/material/icon';
import {MatTableModule} from '@angular/material/table';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {DocumentsService} from '../../services/documents.service';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';

export interface CommandDetails {
  name: string;
  delay: number;
  comment: string;
  control: boolean
  file: File
}

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-affaire-details',
  imports: [
    NavbarComponent,
    HttpClientModule,
    NgForOf,
    MatTab,
    MatTabGroup,
    NgIf,
    MatIcon,
    MatTableModule,
    MatProgressSpinner,
    MatTabLink,
    MatTabsModule,
    NgClass,
    ReactiveFormsModule
  ],
  templateUrl: './affaire-details.component.html',
  styleUrl: './affaire-details.component.css',
  providers: [AffairesService, DocumentsService]
})
export class AffaireDetailsComponent implements OnInit {

  public currentAffairID: string = "";

  private commandDetails: CommandDetails = Object();

  public currentAffair: Affair = Object();
  public isLoading: boolean = false;

  public currentCommandTab: number = 0;

  protected appealForm: FormGroup = new FormGroup({
    unitNumber: new FormControl('', Validators.required),
    mlRef: new FormControl('', Validators.required),
    lastname: new FormControl('', Validators.required),
    firstname: new FormControl('', Validators.required),
    callType: new FormControl('', Validators.required),
    comment: new FormControl('', Validators.required)
  });

  constructor(
    private route: ActivatedRoute,
    private affairesService: AffairesService,
    private router: Router,
    private documentsService: DocumentsService,
    private snackBar: MatSnackBar,
    ) {
  }

  ngOnInit() {
    this.currentAffairID = this.route.snapshot.params['id'];

    this.isLoading = true;

    this.affairesService.getOne(this.currentAffairID).subscribe({
      next: (data) => {
        this.currentAffair = data;

        this.appealForm.patchValue({
          unitNumber: this.currentAffair.unitNumber,
          mlRef: this.currentAffair.mlRef,
        })

        this.isLoading = false;
      },
      error: (err) => {
        this.router.navigate(['affaires']);
      }
    })
  }

  getFileExtension(fileName: string): string {
    const parts = fileName.split('.');
    return parts.length > 1 ? `.${parts.pop()}` : 'N/A';
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      this.commandDetails.file = input.files[0];

      console.log(this.commandDetails.file.name);
    }
  }

  sendNewCommandForm() {
    if (this.appealForm.valid) {
      this.affairesService.appealAffaire(this.appealForm.value).subscribe({
        next: (data) => {
          this.snackBar.open("Formulaire d'appel envoyé avec succès.", 'Fermer', {
            duration: 5000,
          });
        },
        error: (err) => {
          console.log(err);
          this.snackBar.open(err.message, 'Fermer', {
            duration: 5000,
          });
        }
      })
    } else {
      this.snackBar.open("Erreur: formulaire incomplet.", 'Fermer', {
        duration: 5000,
      });
    }
  }

  downloadDocument(document: Document) {
    this.documentsService.download(document);
  }

  backToAffairs(unitID: string) {
    this.router.navigate(['affaires', unitID]);
  }
}
